class ProductNotification extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("[data-notification-form]");
    this.form?.addEventListener("submit", this.onSubmit.bind(this));
    
    // Listen for variant changes
    document.addEventListener('theme:variant:change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    const variant = event.detail.variant;
    if (variant && this.form) {
      // Update the hidden input field
      const variantIdInput = this.form.querySelector("#NotificationFormVariantId");
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }
      
      // Update the form's dataset
      this.form.dataset.variantId = variant.id;
    }
  }

  async onSubmit(event) {
    event.preventDefault();

    const emailInput = this.form.querySelector("#NotificaitonFormEmail");
    const productInput = this.form.querySelector("#NotificationFormProduct");
    const submitButton = this.form.querySelector('button[type="submit"]');
    const email = emailInput.value;
    const variantId = this.form.dataset.variantId;

    if (!email || !variantId || !/@/.test(email)) {
      return;
    }

    // Disable submit button while processing
    submitButton.setAttribute("disabled", true);

    try {
      // Submit to Klaviyo BIS API
      const response = await fetch(
        "//a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=V9V4Jy",
        {
          method: "POST",
          headers: {
            revision: "2024-02-15",
            "Content-Type": "application/json",
            "X-Klaviyo-Onsite": "1",
          },
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email,
                    },
                  },
                },
                channels: ["EMAIL"],
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Subscription failed");
      }

      // Show success message
      this.form.innerHTML = `
        <div class="">
          <p>${
            window.theme?.strings?.productNotificationSuccess ||
            "Thanks! We'll let you know when this is back in stock."
          }</p>
        </div>
      `;
    } catch (error) {
      console.error("BIS subscription error:", error);

      // Show error message
      const errorDiv = document.createElement("div");
      errorDiv.classList.add("error");
      errorDiv.innerHTML = `
        <p>${
          window.theme?.strings?.productNotificationError ||
          "Sorry, there was an error. Please try again."
        }</p>
      `;
      this.form.prepend(errorDiv);

      // Re-enable submit button
      submitButton.removeAttribute("disabled");
    }
  }
}

customElements.define("product-notification", ProductNotification);
